@let dataSource = $dataSource(); @let overrideRowSelection = $overrideRowSelection();

<ag-grid-angular
  style="width: 100%; height: 100%"
  [columnDefs]="$columnDefs()"
  [defaultColDef]="defaultColDef()"
  [rowClassRules]="rowClassRules()"
  [rowData]="dataSource"
  [rowSelection]="overrideRowSelection ? overrideRowSelection : defaultRowSelection"
  [pagination]="true"
  [paginationAutoPageSize]="true"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged()"
  (rowClicked)="$emitRowClicked.emit($event)"
  (cellClicked)="$emitCellClicked.emit($event)"
>
</ag-grid-angular>
